import { useCallback, useLayoutEffect, useState } from 'react';
import { useScreenSizeContext } from '../../../contexts/screen-size-resolution';

const FULL_SCREEN_PERCENTAGE = 30;
const MOBILE_SCREEN_PERCENTAGE = 58;
const ULTRA_MOBILE_SCREEN_PERCENTAGE = 90;

// There is an issue with the carousel where the second and second-to-last elements end up just adding a little space to the
// side of the carousel. This function removes those elements from the array to provide even scrolling.
// It does this by creating an array of sequential numbers up to the length of the array, then removing the second and second-to-last

export const generateArrayForCarousel = (arr) => {
  const result = [];
  for (let i = 0; i <= arr; i++) {
    result.push(i);
  }

  if (result.length >= 4) {
    result.splice(1, 1); // Remove the second element
    result.splice(-2, 1); // Remove the second-to-last element
  }
  return result;
};

export const useAddOnCarousel = (arrayOfAddons) => {
  const [currentIndexPosition, setCurrentIndexPosition] = useState(0);
  const [currentTilePosition, setCurrentTilePosition] = useState(0);
  const arrayForCarousel = generateArrayForCarousel(arrayOfAddons.length);
  const { isMobile, isUltraMobile } = useScreenSizeContext();
  const [slidePercentage, setSlidePercentage] = useState();

  const onClickNext = useCallback(() => {
    if (currentTilePosition === Math.max(...arrayForCarousel)) {
      return;
    }
    setCurrentIndexPosition(currentIndexPosition + 1);
    setCurrentTilePosition(arrayForCarousel[currentIndexPosition + 1]);
  }, [arrayForCarousel, currentTilePosition, currentIndexPosition]);
  const onClickPrev = useCallback(() => {
    if (currentTilePosition === 0) {
      return;
    }
    setCurrentIndexPosition(currentIndexPosition - 1);
    setCurrentTilePosition(arrayForCarousel[currentIndexPosition - 1]);
  }, [arrayForCarousel, currentTilePosition, currentIndexPosition]);

  useLayoutEffect(() => {
    setSlidePercentage(() => {
      if (isUltraMobile) {
        return ULTRA_MOBILE_SCREEN_PERCENTAGE;
      }
      if (isMobile) {
        return MOBILE_SCREEN_PERCENTAGE;
      }
      return FULL_SCREEN_PERCENTAGE;
    });
  }, [isMobile, isUltraMobile]);

  return {
    onClickNext,
    onClickPrev,
    slidePercentage,
    currentTilePosition,
  };
};
